export const isValidEan = (value: string | undefined): boolean => {
  if (!value) return true;
  return value.length === 13 && /^\d+$/.test(value);
};
